export interface AppSettings {
  projectInvoiceApprovers: string;
  workFlowSettings: string;
  budgetingSettings: string;
  configurationSettings?: string;
  quickbookSettings?: string;
  todaysDateSetting?: string;
  loanSettings?: string;
  timeZoneSettings?: string;
  generalSettings?: string;
}

export interface ClientSettings {
  name: string;
  bankSweepApplicable: string;
  creditLineMergingToLoan?: string;
  creditLineActiveInactive?: string;
  allowedPaymentTypes?: string;
  newCreditLineProjectNumber?: string;
  financialSystemToPostInterests: string;
  contactDetails?: string;
  appSettings: AppSettings;
}

export const clientSettings: ClientSettings[] = [
  {
    name: "RCBO",
    bankSweepApplicable: "Y",
    creditLineMergingToLoan: "N",
    creditLineActiveInactive: "Y",
    allowedPaymentTypes: "DNL",
    newCreditLineProjectNumber: "Y",
    financialSystemToPostInterests: "postToNetsuite",
    contactDetails: "Anthony Jung (714)-282-3018",
    appSettings: {
      projectInvoiceApprovers: "Y",
      workFlowSettings: "Y",
      budgetingSettings: "Y",
      configurationSettings: "Y",
      quickbookSettings: "Y",
      todaysDateSetting: "Y",
      loanSettings: "Y",
      timeZoneSettings: "Y",
      generalSettings: "N"
    }
  },
  {
    name: "DC Gary",
    bankSweepApplicable: "N",
    creditLineMergingToLoan: "Y",
    creditLineActiveInactive: "N",
    allowedPaymentTypes: "NON-DNL",
    newCreditLineProjectNumber: "N",
    financialSystemToPostInterests: "postToBlackbaud",
    contactDetails: "Ryan Wilson (219) 769-9292",
    appSettings: {
      projectInvoiceApprovers: "N",
      workFlowSettings: "N",
      budgetingSettings: "N",
      configurationSettings: "Y",
      quickbookSettings: "N",
      todaysDateSetting: "Y",
      loanSettings: "N",
      timeZoneSettings: "N",
      generalSettings: "N"
    }
  }
];

export function getClientDetailsByClientName(clientName: string): ClientSettings | undefined {
  return clientSettings.find((c) => c.name === clientName);
}
